import uuid from "uuid";
import { NOTIFICATION_ADD, NOTIFICATION_DELETE } from "./types";
import { NOTIFICATION_TIMEOUT } from "../constants";

const notificationAdd = (notification) => ({
  type: NOTIFICATION_ADD,
  notification,
});

export const notificationDelete = (notificationId) => ({
  type: NOTIFICATION_DELETE,
  notificationId,
});

export const notificationDisplay = (type, messages) => (dispatch) => {
  const id = uuid.v4();
  dispatch(notificationAdd({ id, type, messages }));
  setTimeout(() => dispatch(notificationDelete(id)), NOTIFICATION_TIMEOUT);
};
